import CollaboratorsGroups from './collaborators-groups';

export default class CollaboratorsGroupsDesktop extends CollaboratorsGroups {
    constructor(...args) {
        super(...args);

        this._isDesktop = (ENV.device == 'desktop');
    }


    bind() {
        super.bind();

        if( this._isDesktop ) {
            for( let i = 0, j = this.dom.views.collaborators.length; i < j; i++ ) {
                this.dom.views.collaborators[i].addEventListener('mouseenter', this._enterItemCollaborator.bind(this), true);
                this.dom.views.collaborators[i].addEventListener('mouseleave', this._leaveItemCollaborator.bind(this), true);
            }
        }
    }

    /**
     * Called when the user enters the area of a collaborator
     */
    _enterItemCollaborator( event ) {

        let target = event.currentTarget;
        let indexItemCollaborator = this.dom.views.collaborators.indexOf( target );

        /** Hide others links **/
        for ( let i = 0, j = this.dom.views.collaborators.length; i < j; i++ ) {
            if( i != indexItemCollaborator ) {
                this.dom.views.collaborators[i].classList.add('hide')
            }
        }
    }

    /**
     * Called when the user leaves the area of a collaborator
     */
    _leaveItemCollaborator( event ) {

        /** Show others links **/
        for ( let i = 0, j = this.dom.views.collaborators.length; i < j; i++ ) {
            this.dom.views.collaborators[i].classList.remove('hide')
        }
    }


    /*
    init() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// src/js/components/collaborators-groups/collaborators-groups.desktop.js